.EmberStatus {
  position: absolute;
  top: 1em;
  left: 0em;
  right: 0em;
  font-size: 0.3em;
  text-align: center;
}
.EmberStatus [number="0"] {
  color: #d54b33;
}
